import React, { useState } from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';
import { Slide } from './slide';
import { slides } from './constants';

export const TeamBlock = () => {
  const [swiper, setSwiper] = useState();

  return (
    <div style={{background: '#25242D', color: 'white', display: 'flex', flexDirection: 'column', gap: '19px'}}>
      <div style={{padding: '0px 16px'}}>
        <div style={{fontSize: '32px', marginTop: '30px', textAlign: 'left', borderBottom: '1px solid white', padding: '0px 0px 20px'}}>
          Meet our team
        </div>
      </div>
      <div>
        <Swiper pagination={true} modules={[Pagination]} className="mySwiperWhite" loop={true} autoHeight={true} onSwiper={(swiper) => setSwiper(swiper)}>
            {slides.map(({img, name, title, bio, email}, index) => (
              <SwiperSlide>
                {({isActive}) => (
                  <Slide
                    key={index}
                    img={img}
                    name={name}
                    title={title}
                    bio={bio}
                    email={email}
                    onExpand={() => swiper?.updateAutoHeight(300)}
                    active={isActive}
                  />
                )}
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  );
}